import {isToday} from 'date-fns';

import {isNil} from 'ramda';

import {parseDate} from 'shared/web';

const PAD_LENGTH = 2;
const PAD_CHAR = '0';

function padTwo(value: number): string {
  return String(value).padStart(PAD_LENGTH, PAD_CHAR);
}

function isInvalidDate(date: Date | null): date is null {
  return isNil(date) || isNaN(date.getTime());
}

function formatTime(date: Date): string {
  return `${padTwo(date.getHours())}:${padTwo(date.getMinutes())}`;
}

/**
 * Formats an ISO 8601 date string to "DD.MM.YYYY HH:MM".
 * When the end falls on today, returns only "HH:MM".
 * Returns empty string for invalid date inputs.
 */
export function formatAuctionEndDate(isoString: string): string {
  const date = parseDate(isoString);
  if (isInvalidDate(date)) {
    return '';
  }

  const time = formatTime(date);
  if (isToday(date)) {
    return time;
  }

  const day = padTwo(date.getDate());
  const month = padTwo(date.getMonth() + 1); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  const year = date.getFullYear();

  return `${day}.${month}.${year} ${time}`;
}
